"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getRenderImages = function (_a) {
    var skuItem = _a.skuItem, skuInfo = _a.skuInfo, image = _a.image, useTransparent = _a.useTransparent, giftCardDesign = _a.giftCardDesign, _b = _a.country, country = _b === void 0 ? 'US' : _b, imageUrl = _a.imageUrl;
    var skuKey = (skuItem && skuItem.id) || (skuInfo && skuInfo.id);
    var renders = {
        default: (skuInfo && skuInfo.render) || skuKey,
        hover: skuInfo && skuInfo.hoverRender,
    };
    var images = image && typeof image === 'object'
        ? image
        : image && typeof image === 'string'
            ? { default: image }
            : skuItem
                ? skuItem.images
                : renders;
    var mainImage = useTransparent && images.transparent
        ? imageUrl + images.transparent + '.png'
        : images.default
            ? imageUrl + images.default + '.jpg'
            : null;
    var hoverImage = images.hover ? imageUrl + images.hover + '.jpg' : null;
    return {
        main: mainImage,
        hover: hoverImage,
    };
};
exports.default = getRenderImages;
